import { inject as p, computed as o } from "vue";
import { menuInjectionKey as h, submenuInjectionKey as M, menuItemGroupInjectionKey as L } from "./ghl-ui.es1068.js";
const a = 8;
function y(u) {
  const v = p(h), {
    props: n,
    mergedCollapsedRef: l
  } = v, d = p(M, null), f = p(L, null), r = o(() => n.mode === "horizontal"), R = o(() => r.value ? n.dropdownPlacement : "tmNodes" in u ? "right-start" : "right"), s = o(() => {
    var e;
    return Math.max((e = n.collapsedIconSize) !== null && e !== void 0 ? e : n.iconSize, n.iconSize);
  }), g = o(() => {
    var e;
    return !r.value && u.root && l.value && (e = n.collapsedIconSize) !== null && e !== void 0 ? e : n.iconSize;
  }), z = o(() => {
    if (r.value || r.value)
      return;
    const {
      collapsedWidth: e,
      indent: t,
      rootIndent: i
    } = n, {
      root: c,
      isGroup: m
    } = u, I = i === void 0 ? t : i;
    return c ? l.value ? e / 2 - s.value / 2 : I : f && typeof f.paddingLeftRef.value == "number" ? t / 2 + f.paddingLeftRef.value : d && typeof d.paddingLeftRef.value == "number" ? (m ? t / 2 : t) + d.paddingLeftRef.value : 0;
  }), S = o(() => {
    const {
      collapsedWidth: e,
      indent: t,
      rootIndent: i
    } = n, {
      value: c
    } = s, {
      root: m
    } = u;
    return r.value || !m || !l.value ? a : (i === void 0 ? t : i) + c + a - (e + c) / 2;
  });
  return {
    dropdownPlacement: R,
    activeIconSize: g,
    maxIconSize: s,
    paddingLeft: z,
    iconMarginRight: S,
    NMenu: v,
    NSubmenu: d
  };
}
export {
  y as useMenuChild
};
